import DefaultLayout from "@core/Components/Layout/DefaultLayout.vue";
import resource from "../../Util/resources";
import Index from './Index';

const routes = [{
    path: '/UcidAnalysis/',
    alias: '/UcidAnalysis/Index',
    component: DefaultLayout,
    meta: {
        title: resource('BreadCrumb_UcidAnalysis_Title'),
        breadcrumb: resource('BreadCrumb_UcidAnalysis')
    },
    children: [{
        name: 'ucid-analysis-index',
        path: ':analysisId',
        component: Index,
        props: true
    }]
}];

export {
    routes
}